import { get } from 'lodash';
import error from './error';

export default (name, options, callback) => (properties, combinedError) => {
  const statusCode = get(combinedError, 'response.status', undefined);
  combinedError.graphQLErrors.forEach(err => {
    const { message } = combinedError;
    let queryName = null;
    if (err) {
      queryName = get(err, 'extensions.typeName');
    }
    error(name, options, callback)({
      ...properties, queryName, message, statusCode
    });
  });
};
